
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2 {...{
      "id": "incremental-export"
    }}>{`Incremental Export`}</h2>
    <h4 {...{
      "id": "background"
    }}>{`Background`}</h4>
    <p>{`Incremental export allows for export of entities after a specified timestamp. This allows for synchronization capability to be built as it makes payloads lighter.`}</p>
    <h4 {...{
      "id": "export-options"
    }}>{`Export Options`}</h4>
    <p>{`New `}<em parentName="p">{`fetchType`}</em>{` added to indicate incremental export. This option can be used with any `}<em parentName="p">{`matchType`}</em>{`. When `}<em parentName="p">{`fetchType`}</em>{` is `}<em parentName="p">{`incremental`}</em>{`, it is necessary to specify the `}<em parentName="p">{`changeMarker`}</em>{` option for incremental export to function, else full export will be performed.`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
 "itemsToExport": [
 { "typeName": "hive_db", "uniqueAttributes": { "qualifiedName": "stocks@cl1" } }
 ],
"options": {
 "fetchType": "incremental",
 "changeMarker": 10000
 }
}`}
    </SyntaxHighlighter>
    <h4 {...{
      "id": "getting-change-marker"
    }}>{`Getting Change Marker`}</h4>
    <p>{`The very first call to export with `}<em parentName="p">{`fetchType`}</em>{` set to `}<em parentName="p">{`incremental`}</em>{` should be made with `}<em parentName="p">{`changeMarker`}</em>{` set to 0. This will perform a full export. The `}<em parentName="p">{`AtlasExportResult`}</em>{` will have the `}<em parentName="p">{`changeMarker`}</em>{` set to a value. This is the value that should be used for a subsequent call to Export.`}</p>
    <h4 {...{
      "id": "skip-lineage-option"
    }}>{`Skip Lineage Option`}</h4>
    <p>{`Export can be performed by skipping lineage information. This avoids all lineage information getting into the exported file.`}</p>
    <h4 {...{
      "id": "benefit-of-incremental-export"
    }}>{`Benefit of Incremental Export`}</h4>
    <p>{`The real benefit of incremental export comes when the export is done with `}<em parentName="p">{`skipLineage`}</em>{` option set to `}<em parentName="p">{`true`}</em>{`. This greatly improves performance when fetching entities that have changed since the last export.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;